module.exports = __webpack_public_path__ + "static/img/eithne.6f372c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/eithne.png
// module id = xi4L
// module chunks = 0